import React, { Component } from "react";

import { background } from "./PopupOptions";

class Background extends Component {
	render() {
		return (
			<div className="background-popup-options" onClick={background}></div>
		);
	}
}

export default Background;
